import { gql } from "@apollo/client";

const USER_REF = `updatedBy { id name }`;
export const PROJECT_TYPE_FIELDS = `
  id
  name
  shortDescription
  displayOrder
  displayPlace
  isVisible
  icon
  visiblePackageTierCount
  updatedAt
  ${USER_REF}
`;
export const PROJECT_QUESTION_FIELDS = `
  id
  projectTypeId
  label
  answerType
  isRequired
  unit
  options
  placeholder
  displayOrder
  isMainQuantity
`;
export const PROJECT_PACKAGE_ITEM_FIELDS = `
  id
  projectTypeId
  budgetTier
  name
  title
  shortDescription
  priceFromMillion
  priceToMillion
  priceNote
  isVisible
  productCount
  version
  updatedAt
  ${USER_REF}
`;
export const PROJECT_PACKAGE_DETAIL_FIELDS = `
  ${PROJECT_PACKAGE_ITEM_FIELDS}
  projectTypeName
  products {
    productId
    productName
    model
    imageUrl
    quantity
    unitPrice
    lineTotal
    displayLabel
    displayOrder
  }
  totalProductValue
`;
const PAGINATION = `pagination { total offset limit }`;

export const PROJECT_TYPE_LIST = gql`
  query ProjectTypeList($keyword: String, $page: Int32, $size: Int32) {
    projectConfig {
      listProjectTypes(keyword: $keyword, page: $page, size: $size) {
        ${PAGINATION}
        items { ${PROJECT_TYPE_FIELDS} }
      }
    }
  }
`;

export const PROJECT_TYPE_DETAIL = gql`
  query ProjectTypeDetail($id: ID!) {
    projectConfig {
      getProjectType(id: $id) { ${PROJECT_TYPE_FIELDS} }
    }
  }
`;

export const PROJECT_QUESTION_LIST = gql`
  query ProjectQuestionList($projectTypeId: ID!) {
    projectConfig {
      listProjectQuestions(projectTypeId: $projectTypeId) { ${PROJECT_QUESTION_FIELDS} }
    }
  }
`;

export const PROJECT_PACKAGE_LIST = gql`
  query ProjectPackageList($projectTypeId: ID!) {
    projectConfig {
      listProjectPackages(projectTypeId: $projectTypeId) { ${PROJECT_PACKAGE_ITEM_FIELDS} }
    }
  }
`;

export const PROJECT_PACKAGE_DETAIL = gql`
  query ProjectPackageDetail($id: ID!) {
    projectConfig {
      getProjectPackage(id: $id) { ${PROJECT_PACKAGE_DETAIL_FIELDS} }
    }
  }
`;

export const PROJECT_CATALOG_PRODUCTS = gql`
  query ProjectCatalogProducts($keyword: String, $page: Int32, $size: Int32) {
    projectConfig {
      searchCatalogProducts(keyword: $keyword, page: $page, size: $size) {
        ${PAGINATION}
        items { productId productName model imageUrl unitPrice }
      }
    }
  }
`;
